<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8GdYmh/tc-custom/9783988260314.jpg?1704425053456" alt="This image is the cover for the book The Hollow Lens and Assignats, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Hollow Lens and Assignats, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Excerpt: “In the 'argot' of the underworld, Chester Fay, alias Edward Letchmere, an expert on other people’s strong-boxes, had lammistered to Short Hills, California, where an excellent golf-links surrounds a half-hotel, half-clubhouse of the superior order. After finishing a game, upon the twelfth day of his stay at Short Hills, Fay tossed his golf-bag to the turf, dismissed his caddy and sat down at the Nineteenth Hole, where refreshments were at that time available. The girl who entered his life, a few minutes after he was seated, came diagonally from the clubhouse. He mentally concluded that she had been waiting on the porch for the game to finish. She wore a picture-hat, carried a parasol and was extremely cool, as was attested by her manner as she drew a chair up to his table and said: “I’m Charlie Laurie’s only daughter.” Had the California sky fallen upon the links, Fay would not have been more surprised. Charlie Laurie was serving fifty years in the Isolation Section of Dannemora for the crime, committed against the dignity of New York State, of forcing open a national bank, seizing the contents of the vault and escaping to Argentina, where he was later turned up by a former pal."</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Henry Leverage
      </h2>
      
      <p class="authorDescription body article">Henry Leverage was a writer, known for The Twinkler (1916) and Whispering Wires (1926). He was previously married to May Collins. He died on February 24, 1931 in New York City, New York, USA.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4a26631e